<template>

  <div class="stock-slip-reports">
     <KTCodePreview v-bind:title="'Báo cáo xuất nhập kho'"
      > <template v-slot:toolbar
        >
        <div class="row">

          <div>
             <b-dropdown
              size="sm"
              id="dropdown-1"
              right
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="fas fa-cog"
                ></i
                > <span class="font-weight-bolder">Thao tác</span> </template
              > <b-dropdown-item @click="reportClick"
                > <span
                  > <i
                    style="font-size: 1rem"
                    class="far fa-file-excel"
                  ></i
                  > &nbsp; Xuất Excel</span
                > </b-dropdown-item
              > </b-dropdown
            >
          </div>

        </div>
         </template
      > <template v-slot:preview
        > <b-row class="mb-5"
          > <b-col
            >
            <div class="d-flex justify-content-center align-items-center">
               <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.start"
                v-model="dpForm.startDate"
              ></date-picker
              > <span class="ml-1 mr"></span> <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.end"
                v-model="dpForm.endDate"
              ></date-picker
              >
            </div>
             </b-col
          > <b-col
            > <BDropdownCustom
              v-model="valueStockSlipTypes"
              :options="stockSlipTypeOptions"
              :placeholder="'loại phiếu'"
              :matchKey="['name']"
              :searchable="true"
            /> </b-col
          > <b-col
            > <b-input
              size="sm"
              placeholder="Nhập mã, tên sản phẩm"
              v-model="searchProduct"
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col
            > <treeselect
              v-model="valueProviders"
              :multiple="true"
              :async="true"
              :load-options="loadProviderOptions"
              placeholder="Tìm NCC..."
              noResultsText="Không tìm thấy kết quả"
              loadingText="Đang tìm kiếm..."
              searchPromptText="Nhập để tìm kiếm..."
              :clearable="true"
              :cache-options="false"
              valueFormat="object"
            /> </b-col
          > <b-col
            > <BDropdownCustom
              v-model="valueStore"
              :options="filterdOptionsStore"
              :placeholder="'cửa hàng'"
              :matchKey="['name']"
              :searchable="true"
            /> </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col> </b-col> <b-col> </b-col> <b-col></b-col> <b-col></b-col> </b-row
        > <b-row class="mb-5"
          > <b-col md="1"
            > <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            > </b-col
          > </b-row
        > <b-table
          :items="stockSlipsReports"
          :fields="fields"
          sort-by="count"
          class="table-bordered table-hover col-md-12"
          :busy="onLoading"
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            ></vcl-table
            > </template
          > <template v-slot:cell(count)="row"
            >
            <div style="text-align: center">
               <span
                v-text="row.item.count"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(productId)="row"
            > <ProductCommonInfo :product="row.item" /> </template
          > <template v-slot:cell(providerName)="row"
            >
            <div class="d-flex flex-column customer-info">
              <span class="customer-name"> {{ row.item.providerName}} </span>
              <span v-if="row.item.providerPhoneNo" class="customer-phone">
                <span class="text-warning">SĐT:</span> {{ row.item.providerPhoneNo }}
              </span>
              <span v-if="row.item.providerAddress" class="customer-address">
                <span class="text-warning">ĐC:</span> {{ row.item.providerAddress }}
              </span>
            </div>
             </template
          > <template v-slot:cell(stockSlipCode)="row"
            >
            <div class="d-flex flex-column">
               <span
                class="stock-slip-code"
                @click="linkToStockSlip(row.item)"
                > {{ row.item.stockSlipCode }} </span
              > <span class="warehouse-name"> {{ row.item.sourceWarehouseName }} </span>
              <span class ="created-at text-muted">Ngày tạo: {{ row.item.createdAt }}</span>
            </div>
             </template
          > </b-table
        > <b-row
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng: {{ convertPrice(totalItems) }}
            </p>
             </b-col
          > <b-col
            > <b-pagination-nav
              v-model="page"
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchData"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1 "
              last-class="page-item-last btn btn-icon btn-sm m-1 "
              page-class="btn btn-icon btn-sm border-0 m-1"
              > <template v-slot:first-text
                > <span> <i class="ki ki-bold-double-arrow-back icon-xs"></i> </span> </template
              > <template v-slot:prev-text> <i class="ki ki-bold-arrow-back icon-xs"></i> </template
              > <template v-slot:next-text> <i class="ki ki-bold-arrow-next icon-xs"></i> </template
              > <template v-slot:last-text
                > <span class="text-info"
                  > <i class="ki ki-bold-double-arrow-next icon-xs"></i> </span
                > </template
              > </b-pagination-nav
            > </b-col
          > </b-row
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import ApiService from '@/core/services/api.service'
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import moment from 'moment'
  import axios from 'axios'
  import { VclTable } from 'vue-content-loading'
  import cloneDeep from 'lodash/cloneDeep'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import Treeselect from '@riophae/vue-treeselect'
  import { searchCustomers } from '@/utils/customerSearch'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import decounce from 'debounce'
  import { STOCK_SLIP_TYPE } from '@/utils/enum'
  import { BASE_URL, TIME_TRIGGER } from '@/utils/constants'
  import { convertPrice } from '@/utils/common'
  import fileDownload from '@/utils/file-download'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        dpForm: {
          startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
          endDate: '',
        },
        dpConfigs: {
          start: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
          end: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        onLoading: false,
        currentPage: 0,
        totalPages: 1,
        count: 1,
        totalItems: 0,
        stockSlipsReports: [],
        page: 1,
        limit: 10,
        valueProviders: [],
        searchProduct: '',
        filteredOptionsProduct: [],
        optionsProduct: [
          {
            data: [],
          },
        ],
        valueStore: [],
        filterdOptionsStore: [],
        valueStockSlipTypes: [],
        stockSlipTypeOptions: [
          {
            code: STOCK_SLIP_TYPE.IMPORT_PROVIDER,
            name: 'Nhập kho NCC',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_PROVIDER,
            name: 'Xuất trả NCC',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.TRANSFER,
            name: 'Chuyển kho',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.REQUEST_TRANSFER,
            name: 'Yêu cầu chuyển kho',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE,
            name: 'Xuất kho bán lẻ',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE_WHOLSE,
            name: 'Xuất kho bán buôn',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_BILL,
            name: 'Nhập kho từ phiếu trả hàng',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_ORDER,
            name: 'Nhập kho từ đơn chuyển hoàn',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_TO_SHIPPING,
            name: 'Xuất kho giao hàng',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_FROM_TRADE_IN,
            name: 'Nhập kho thu cũ',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_WARRANTY,
            name: 'Nhập kho bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_WARRANTY,
            name: 'Xuất kho bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_HOLDING,
            name: 'Nhập giữ hàng',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_HOLDING,
            name: 'Xuất giữ hàng',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.TRANSFER_WARRANTY_STOCK,
            name: 'Chuyển kho bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.REQUIRE_EXPORT_WARRANTY_STOCK,
            name: 'Yêu cầu xuất chuyển kho bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.REQUIRE_IMPORT_WARRANTY_STOCK,
            name: 'Yêu cầu nhập chuyển kho bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_WARRANTY_BILL,
            name: 'Nhập kho từ hóa đơn bảo hành',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_WARRANTY_FROM_BILL,
            name: 'Nhập kho bảo hành từ hóa đơn',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_STOCK_BY_INVENTORY_CHECK,
            name: 'Xuất kho từ phiếu kiểm kho',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_STOCK_BY_INVENTORY_CHECK,
            name: 'Nhập kho từ phiếu kiểm kho',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_LENDING,
            name: 'Xuất kho cho mượn máy',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_STOCK_LENDING,
            name: 'Nhập kho cho mượn máy',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_WARRANTY_FROM_PROVIDER,
            name: 'Nhập kho bảo hành nhà NCC',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT,
            name: 'Nhập kho chuyển mã sản phẩm IMEI',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_PRODUCT,
            name: 'Xuất kho chuyển mã sản phẩm IMEI',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI,
            name: 'Nhập kho đổi IMEI',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_IMEI,
            name: 'Xuất kho đổi IMEI',
            checked: false,
          },
          {
            code: STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL,
            name: 'Xuất kho bảo hành từ hóa đơn bảo hành',
            checked: false,
          },
        ],
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '4%',
            },
            tdClass: 'sttClass',
          },
          {
            key: 'productId',
            label: 'Sản phẩm',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          },
          {
            key: 'stockSlipCode',
            label: 'Mã phiếu kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          },
          {
            key: 'providerName',
            label: 'KH/NCC',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          },
          {
            key: 'quantity',
            label: 'SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
          },
          {
            key: 'unitPrice',
            label: 'Đơn giá',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return value ? convertPrice(value) : 0
            },
          },
          {
            key: 'discountAmount',
            label: 'Chiết khấu',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return value ? convertPrice(value) : 0
            },
          },
          {
            key: 'vatAmount',
            label: 'VAT',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return value ? convertPrice(value) : 0
            },
          },
        ],
        linkGen: (pageNum) => {
          return pageNum === 1 ? '?' : `?page=${pageNum}`
        },
      }
    },
    async created() {
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.optionsStore = []
      stores.map((element) => {
        const option = {
          code: element.id,
          name: element.name,
          shortName: element.shortName,
          checked: false,
        }
        this.optionsStore.push(option)
      })
      this.filterdOptionsStore = cloneDeep(this.optionsStore)
      if (currentStoreId) {
        this.valueStore = [
          {
            code: currentStoreId,
            name: currentStoreName,
            checked: true,
          },
        ]
      }
      this.debounceLoadProviders = decounce(async (searchQuery, callback) => {
        try {
          const items = await searchCustomers(searchQuery)
          callback(
            null,
            items.map((c) => ({ id: c.id, label: c.fullName })),
          )
        } catch (err) {
          callback(err)
        }
      }, TIME_TRIGGER)
      this.fetchData()
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kho hàng', route: 'stock-slip-reports' },
        { title: 'Báo cáo xuất nhập kho' },
      ])
    },
    components: {
      KTCodePreview,
      BDropdownCustom,
      Treeselect,
      VclTable,
      ProductCommonInfo,
    },
    methods: {
      convertPrice,
      loadProviderOptions({ action, searchQuery, callback }) {
        if (action === 'ASYNC_SEARCH') {
          this.debounceLoadProviders(searchQuery, callback)
        }
      },
      onFilter() {
        this.$route.query.page = 1
        this.$router.push({
          name: 'stock-slip-reports',
        })
        this.fetchData()
      },
      setQueryParams() {
        let listStoreId = []
        if (this.valueStore.length) {
          listStoreId = this.valueStore.map(({ code }) => code)
        }
        let listTypeId = []
        if (this.valueStockSlipTypes.length) {
          listTypeId = this.valueStockSlipTypes.map(({ code }) => code)
        }
        let listProviderId = []
        if (this.valueProviders.length) {
          listProviderId = this.valueProviders.map((p) => p.id)
        }
        return {
          fromDate: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          toDate: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          searchProduct: this.searchProduct,
          storeIds: listStoreId,
          types: listTypeId,
          providerIds: listProviderId,
        }
      },
      fetchData: async function () {
        this.onLoading = true
        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }

        const queryParams = this.setQueryParams()

        const params = {
          page: this.page,
          limit: 10,
          ...queryParams,
        }
        ApiService.query('v1/stock-slips/reports', { params })
          .then((response) => {
            this.stockSlipsReports = []
            const stockResponse = response.data.data.data
            this.totalPages = response.data.data.totalPage
            this.currentPage = response.data.data.currentPage
            this.totalItems = response.data.data.total
            let result = []
            stockResponse.forEach((item, index) => {
              const vatAmount = item.beforeVatPrice
                ? Number(item.unitPrice) - Number(item.beforeVatPrice)
                : 0
              const stock = {
                ...item,
                vatAmount,
                count: this.currentPage >= 2 ? index + 1 + this.currentPage * 10 - 10 : index + 1,
                createdAt: moment(item.createdAt).format('HH:mm:ss DD/MM/YYYY'),
              }
              result.push(stock)
              this.stockSlipsReports = [...new Set(result)]
            })
            this.onLoading = false
          })
          .catch(() => {
            this.onLoading = true
          })
      },
      linkToStockSlip: function (item) {
        if (item.stockSlipType === 1) {
          const { href } = this.$router.resolve({
            name: 'edit-inventory-receipt',
            query: { id: item.stockSlipId },
          })
          window.open(href, '_blank')
        } else if (item.stockSlipType === 2) {
          const { href } = this.$router.resolve({
            name: 'edit-inventory-dispatch',
            query: { id: item.stockSlipId },
          })
          window.open(href, '_blank')
        } else if (item.stockSlipType === 3) {
          const { href } = this.$router.resolve({
            name: 'edit-inventory-transfer',
            query: { id: item.stockSlipId },
          })
          window.open(href, '_blank')
        }
      },
      reportClick: async function () {
        const queryParams = this.setQueryParams()
        const options = {
          url: `${BASE_URL}v1/stock-slips/reports/exports`,
          method: 'GET',
          responseType: 'blob',
          params: {
            ...queryParams,
          },
        }
        await axios(options).then((response) => {
          const fileName = fileDownload.getFileName(response)
          fileDownload.createFile(response.data, fileName)
        })
      },
    },
  }
</script>

<style lang="scss">
  .stock-slip-reports {
  .table th,
  .table td {
    padding: 0.25rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .stock-slip-code {
    color: #0d6efd;
    cursor: pointer;
    font-weight: 600;
  }

  .stock-slip-code:hover {
    text-decoration: underline;
  }

  .warehouse-name {
    color: #555;
    font-size: 12px;
    margin-top: 2px;
  }

  .created-at {
    font-size: 12px;
    margin-top: 2px;
  }

  .customer-info {
    font-size: 12px;
  }

  .customer-name {
    font-weight: 600;
    color: #181c32;
    font-size: 13px;
  }

  .customer-phone,
  .customer-address {
    font-size: 12px;
    margin-top: 2px;
  }
}
</style>

